<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-prologue element-with-heading" id="prologue">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">PROLOGUE</h1>
</div>
<div class="heading-ornament-block heading-ornament-aspect-wide">
<div class="heading-ornament-size-container">
<img alt="" class="heading-ornament-image" src="images/heading-swash-ornate-screen.png"/>
</div>
</div>
</div>
</div>
</div>
<div class="text" id="prologue-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center">THE NARRATIVE OF ARTHUR GORDON PYM</p>
<p class="alignment-block-content alignment-block-content-center">OF NANTUCKET</p>
</div>
</div>
<p class="implicit-break"></p>
<p class="first first-in-chapter first-full-width first-with-first-letter-c"><span class="drop-cap">C</span>OMPRISING THE DETAILS OF A MUTINY AND ATROCIOUS BUTCHERY ON BOARD THE AMERICAN BRIG <i>GRAMPUS</i>, ON HER WAY TO THE SOUTH SEAS, IN THE MONTH OF JUNE 1827.</p>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">WITH AN ACCOUNT</span> OF THE RECAPTURE OF THE VESSEL BY THE SURVIVERS; THEIR SHIPWRECK AND SUBSEQUENT HORRIBLE SUFFERINGS FROM FAMINE; THEIR DELIVERANCE BY MEANS OF THE BRITISH SCHOONER <i>JANE GUY</i>; THE BRIEF CRUISE OF THIS LATTER VESSEL IN THE ANTARCTIC OCEAN; HER CAPTURE, AND THE MASSACRE OF HER CREW AMONG A GROUP OF ISLANDS IN THE EIGHTY-FOURTH PARALLEL OF SOUTHERN LATITUDE; TOGETHER WITH THE INCREDIBLE ADVENTURES AND DISCOVERIES STILL FARTHER SOUTH TO WHICH THAT DISTRESSING CALAMITY GAVE RISE.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?60032f00